import Commitment from "./Commitments";
import Loader from "../Commons/Loader";
import Pagination from "../Commons/Pagination/Main";
import NoData from "../Commons/NoData";
import { useState, useRef, useEffect, useContext } from "react";
import { CommitmentContext } from "../Context/Commitment";
import { fetchCommitmentAction } from "../Context/Commitment/actions";

const limit = 10;

const Ogp = () => {
  const [offset, setOffset] = useState(0);
  const { commitmentState, dispatch } = useContext(CommitmentContext);
  const { commitments: { data: FixOurOilCommitments = [], total: count = 0 } = {}, fetchingCommitments: loading } = commitmentState;

  const paginationHandler = ({ selected }) => {
    setOffset(limit * selected)
  };

  useEffect(() => {
    fetchCommitmentAction({
      limit,
      page: (offset / limit) + 1,
    })(dispatch);
  }, [offset, dispatch]);

  return (
    <div className="md:pt-12 lg:pt-20">
      <div className="progresstracker w-full rounded-sm h-184 lg:h-300">
        <h1 className="text-2xl text-white font-sans leading-9 font-medium md:text-2 md:leading-12 lg:text-5xl lg:leading-72">
          Progress Tracker-O.G.P
        </h1>
      </div>
      {loading && <Loader />}

      {!loading && !!FixOurOilCommitments.length && (
        <>
          {FixOurOilCommitments?.map((commitment) => (
            <div key={commitment.id} className="pb-10 md:pb-12 lg:pb-20">
              <Commitment commitment={commitment} />
            </div>
          ))}
          {(count / limit) > 1 && <div className="w-full flex items-center justify-center py-10">
            <Pagination
              currentPage={!!offset ? Number(offset) / limit : 0}
              onPageChange={paginationHandler}
              to={Number(count) / limit}
            />
          </div>}
        </>
      )}
      {!loading && !FixOurOilCommitments.length && (
        <div className="pt-10 px-6 md:px-12 lg:px-0 xl:px-12">
          <NoData />
        </div>
      )}
    </div>
  );
};

export default Ogp;
